import { useState } from "react";

import ic_delete_invoices from "assets/images/ic_delete_invoices.svg";
import ic_generate_invoice from 'assets/images/ic_generate_invoice.svg';
import ic_clone_account from "assets/images/ic_clone_account.svg";
import ic_edit from "assets/images/ic_edit.svg";
import ic_update_status from "assets/images/ic_update_status.svg";
import { isArrayEmpty, isArrayLengthEqual, isArrayNotEmpty } from "functions";
import { Toaster } from "components/notification/Toaster";

export function useTabs({
    setSelectedAccount = () => {},
    setIsFormVisible = () => {}, setIsEditingAccount = () => {},
    generateInvoice_requesting, setIsModalVisible_generateInvoice = () => {},
    setIsModalVisible_deleteAccount = () => {},
    setIsModalVisible_updateStatus = () => {}, setIsCloning = () => {}
}) {
    const [currentTabId, setCurrentTabId] = useState("pending");

    let tabsDetails = [
        {
            id: "pending",
            text: "Pending",
            filters: {
                status: 1
            }
        },
        {
            id: "confirmed",
            text: "Confirmed",
            filters: {
                status: 0
            }
        },
        {
            id: "completed",
            text: "Completed",
            filters: {
                status: 2
            }
        },
        {
            id: "inactive",
            text: "Inactive",
            filters: {
                status: 3
            }
        },
    ];

    let submenuActions = (selectedAccounts) => {

        let updateStatusAction = {
            icon: ic_update_status,
            label: "Update Status",
            // isDisabled: isUserAccessDenied(props, "Internal_ProformaInvoice_Delete"),
            onClick: () => { 
                if (isArrayNotEmpty(selectedAccounts)) {
                    setSelectedAccount(selectedAccounts);
                    setIsModalVisible_updateStatus(true);
                }
                else Toaster({ type: "info", msg: "Please select at least 1 account" });
            },
        };
        let cloneAction = {
            icon: ic_clone_account,
            label: "Clone Account",
            onClick: () => {
                if (isArrayNotEmpty(selectedAccounts) &&
                    isArrayLengthEqual(selectedAccounts, 1)) {
    
                    setSelectedAccount(selectedAccounts);
                    setIsFormVisible(true);
                    setIsEditingAccount(false);
                    setIsCloning(true);
                }
                else if (isArrayEmpty(selectedAccounts))
                    Toaster({ type: "info", msg: "Please select a row" });
                else Toaster({ type: "info", msg: "Please select only 1 row" });
            },
        };
        let generateInvoiceAction = {
            icon: ic_generate_invoice,
            label: "Generate Invoice",
            isLoading: generateInvoice_requesting,
            // isDisabled: isUserAccessDenied(props, "Internal_ProformaInvoice_Delete"),
            onClick: () => { 
                setSelectedAccount(selectedAccounts);
                setIsModalVisible_generateInvoice(true);
            },
        };
        let editAccountAction = {
            icon: ic_edit,
            label: "Edit Account",
            // isDisabled: isUserAccessDenied(props, "Internal_ProformaInvoice_Delete"),
            onClick: () => { 
                if (isArrayNotEmpty(selectedAccounts) &&
                    isArrayLengthEqual(selectedAccounts, 1)) {
        
                    setSelectedAccount(selectedAccounts);
        
                    setIsFormVisible(true);
                    setIsEditingAccount(true);
                }
                else if (isArrayEmpty(selectedAccounts))
                    Toaster({ type: "info", msg: "Please select an account" });
                else Toaster({ type: "info", msg: "Please select only 1 account" });
            },
        };
        let deleteInvoiceAction = {
            icon: ic_delete_invoices,
            label: "Delete Account",
            // isDisabled: isUserAccessDenied(props, "Internal_ProformaInvoice_Delete"),
            onClick: () => { 
                if (isArrayNotEmpty(selectedAccounts)) {
                        setSelectedAccount(selectedAccounts);
                        setIsModalVisible_deleteAccount(true);
                }
                else Toaster({ type: "info", msg: "Please select at least 1 account" });
            },
        };
    
        let actions = [];
        switch (currentTabId) {
            case "pending":
                actions.push(updateStatusAction);
                actions.push(editAccountAction);
                actions.push(cloneAction);
                actions.push(deleteInvoiceAction);
                break;
            case "confirmed":
                actions.push(updateStatusAction);
                actions.push(generateInvoiceAction);
                actions.push(cloneAction);
                actions.push(deleteInvoiceAction);
                break;
            case "completed":
                actions.push(updateStatusAction);
                actions.push(cloneAction);
                actions.push(deleteInvoiceAction);
                break;
            case "inactive":
                actions.push(cloneAction);
                actions.push(deleteInvoiceAction);
                break;
        }

        return actions;
    };

    return {
        currentTabId, setCurrentTabId,
        tabsDetails, submenuActions
    }
}